import { Flex, Heading } from '@everlywell/ui-kit';
import SectionContainer from 'components/PageSections/components/SectionContainer';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Media } from 'utils/types/contentfulTypes';

export type PressSectionV2Props = {
  title?: string;
  media?: Media[];
};

/**
 * PressSection is a component that displays a title and an array of images
 */
export default function PressSectionV2({
  title,
  media,
}: PressSectionV2Props): JSX.Element {
  return (
    <SectionContainer size="sm" textAlign="center">
      {title ? (
        <Heading
          as="h2"
          size="sm"
          color="tints.darkGrey"
          marginBottom={['5', '10']}
          fontWeight="normal"
        >
          {title}
        </Heading>
      ) : null}
      <Flex
        gap={['5', '10']}
        alignContent="center"
        alignItems="center"
        flexFlow={['column', 'row']}
        justifyContent="center"
      >
        {media
          ? media.map(
              (item, index) =>
                item.desktopImage?.gatsbyImageData && (
                  <GatsbyImage
                    key={index}
                    image={item.desktopImage?.gatsbyImageData}
                    alt={item.desktopImageAltText || ''}
                  />
                ),
            )
          : null}
      </Flex>
    </SectionContainer>
  );
}
